import { Grid, Box } from '@mui/material';

import TypographyLevel from 'shared/components/Typography';
// import { ButtonComp } from 'shared/components/AppComponents';
import { ReactElement } from 'react';

/**
 * Props for the MCHeaderMain component.
 */
type MCHeaderMain = {
    onClickButtonMember: () => void;
};

/**
 * Component for the main header in the Manage Clients page.
 * @param {MCHeaderMainProps} props - The component props.
 * @returns {ReactElement} React element representing the main header component.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MCHeaderMain: React.FC<MCHeaderMain> = (props): ReactElement => {
    const {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onClickButtonMember,
    } = props;
    return (
        <Grid className="header-list-access" container columnSpacing={0}>
            <Grid className="header-item" xs={12} sm={12} md={9} lg={10} item>
                <Box className="header-title">
                    <TypographyLevel
                        className="header-heading"
                        variant="two"
                        component="h3"
                    >
                        Access Management
                    </TypographyLevel>
                </Box>
            </Grid>

            <Grid className="header-item" item xs={12} sm={6} md={3} lg={2}>
                <Box className="header-container">
                    {/* <ButtonComp
                        onClick={onClickButtonMember}
                        type="primary"
                        className="header-button-add-member"
                    >
                        Add new member
                    </ButtonComp> */}
                </Box>
            </Grid>
        </Grid>
    );
};
export default MCHeaderMain;
